// extracted by mini-css-extract-plugin
export var labelWrapper = "_gt-0";